import { Pie, PieChart, ResponsiveContainer } from "recharts";
import { useGetDeviceListingQuery } from "../../../api/network/camerasAdminVMApiService";
import { APP_CONFIG } from "../../../constants/constants";
import { useState } from "react";
import { CameraListingPayload } from "../../../api/types/Camera";

const OnlineCamerasOverview = () => {
  const [cameraManagementQueryParams, setCameraManagementQueryParams] =
    useState<CameraListingPayload>({
      keyword: "",
      model: "",
      status: "",
      offset: 0,
      limit: APP_CONFIG.LISTINGS.XL_PAGE_SIZE,
    });

  // Fetch camera listing data
  const {
    data: dataDeviceListing,
    isFetching: isFetchingDeviceListing,
    error,
    refetch,
  } = useGetDeviceListingQuery(
    {
      ...cameraManagementQueryParams,
      offset: cameraManagementQueryParams.offset,
    },
    {
      refetchOnMountOrArgChange: true, // caching removed to ensure listing always shows correct status
    }
  );

  const { data: results } = dataDeviceListing || {};

  const onlineCameras =
    results?.filter((item) => item.is_online === "online")?.length || 0;
  const totalCameras =
    results?.filter((item) => item.cid !== null)?.length || 0;

  // Find percentage of online cameras
  const onlinePercentage =
    totalCameras > 0 ? ((onlineCameras || 0) / totalCameras) * 100 : 0;
  const data = [
    { name: "Online", value: onlineCameras || 0, fill: "#229F45" },
    {
      name: "Offline",
      value: totalCameras ? totalCameras - (onlineCameras || 0) : 0,
      fill: "#E5E7EB",
    },
  ];
  return (
    <div className="bg-white rounded-lg border-2 shadow-lg h-48 p-4 gap-1 flex flex-row">
      <div className="flex-1">
        <h1 className="font-semibold text-lg leading-5 mb-2 col-span-12 text-left">
          {"Online Cameras"}
        </h1>
        <h1 className="text-blue-500 text-2xl font-bold">{onlineCameras}</h1>
        <div className="col-span-6 place-content-left mt-4">
          <h1 className="font-semibold text-sm leading-5 tracking-tight align-middle">
            {"Total Cameras in Services"}
          </h1>
          <h1 className="text-blue-500 text-2xl font-bold">{totalCameras}</h1>
        </div>
      </div>
      <ResponsiveContainer className={"flex-1 h-full mt-5 w-full"}>
        <PieChart
          width={100}
          height={100}
          className="h-full flex flex-1 items-center justify-center self-center"
        >
          <Pie
            dataKey="value"
            startAngle={180}
            endAngle={0}
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={75}
            innerRadius={50}
          ></Pie>
          <foreignObject
            // x={"0%"}
            y={"-10%"}
            width={"100%"}
            height={"100%"}
          >
            <div className="flex flex-col items-center justify-center w-full h-full">
              <h1 className="text-sm font-bold">
                {`${onlinePercentage.toFixed(0)}%`}
              </h1>
              <span className="text-xs text-gray-500">{`Online Cameras`}</span>
            </div>
          </foreignObject>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OnlineCamerasOverview;
